import { useQuery, gql } from "@apollo/client";

import { useAppDispatch } from "../../app/hooks";
import { showErrorSnackbar } from "../snackbar/snackbarSlice";
import { setProcesses, setSteps } from "./processSlice";

export const useStepsQuery = (page: number, perPage: number) => {
  const dispatch = useAppDispatch();

  return useQuery(GETSTEPS, {
    variables: { page: page, perPage: perPage, sort: "UPDATEDAT" },
    onCompleted: (data) => {
      dispatch(setSteps(data.stepTemplatePagination));
    },
    onError: (err) => {
      dispatch(showErrorSnackbar(err.message));
    },
  });
};

export const useProcessQuery = () => {
  const dispatch = useAppDispatch();

  return useQuery(GETPROCESS, {
    variables: { page: 1, perPage: 15, sort: "UPDATEDAT" },
    onCompleted: (data) => {
      dispatch(setProcesses(data.processTemplatePagination));
    },
    onError: (err) => {
      dispatch(showErrorSnackbar(err.message));
    },
  });
};

const GETSTEPS = gql`
  query stepTemplatePagination($page: Int!, $perPage: Int!, $sort: SortFindManyStepTemplateInput) {
    stepTemplatePagination(page: $page, perPage: $perPage, sort: $sort) {
      items {
        _id
        name
        default
        type
        automatedType
        subSteps {
          _id
          name
          emailTemplate {
            _id
          }
          type
        }
        emailTemplate {
          name
          _id
        }
        textTemplate {
          _id
          name
        }
        createdAt
        updatedAt
      }
      count
    }
  }
`;

const GETPROCESS = gql`
  query processTemplatePagination($page: Int!, $perPage: Int!, $sort: SortFindManyProcessTemplateInput) {
    processTemplatePagination(page: $page, perPage: $perPage, sort: $sort) {
      items {
        _id
        type
        name
        default
        userType
        sourceType
        leaseType
        viewType
        stepTemplates {
          _id
          name
          type
        }
        timeBetweenSteps {
          days
          hours
          minutes
          type
        }
        createdAt
        updatedAt
      }
      count
    }
  }
`;
